import { render, staticRenderFns } from "./ColorInput.vue?vue&type=template&id=32bfa68f&"
import script from "./ColorInput.vue?vue&type=script&lang=ts&"
export * from "./ColorInput.vue?vue&type=script&lang=ts&"
import style0 from "./ColorInput.vue?vue&type=style&index=0&id=32bfa68f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports